import Debug from 'debug';
import { SelectionState, EditorState, Modifier } from 'draft-js';
import { decorateTitle } from "./decorateTitle";

const debug = Debug('title-plugin');

const defaultOptions = {
	entityTypes: ['IMAGE', 'GALLERY', 'VIDEO']
}


/**
 * @returns {DraftEditorPlugin}
 */
export function createTitlePlugin(options = defaultOptions) {
	const { entityTypes } = { ...defaultOptions, ...options };

	return {
		name: 'title',

		/**
		 * 返回支持 focusable 的 Atomic 插件
		 */
		decoratePlugin(plugin) {
			return decorateTitle(plugin, entityTypes);
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/titlePlugin/createTitlePlugin.js